import {
  ON_GEL_UPDATE,
  ON_GEL_SELECT,
  ON_SUBMIT,
  ON_RESET,
  CLOSE_FEEDBACK,
  ON_DROP_DOWN_SUBMIT,
  ON_DROP_DOWN_RESET,
  CLOSE_DROP_DOWN_FEEDBACK,
  ON_DROP_DOWN_UPDATE,
  ON_DROP_DOWN_SELECT
} from '../../Redux.constants';
import {
  onGelUpdate,
  onGelSelect,
  onCloseFeedback,
  onGelSubmit,
  onGelReset,

  onDropDownSubmit,
  onDropDownReset,
  onDropDownCloseFeedback,
  onDropDownUpdate,
  onDropDownSelect
} from './helper';

export function GelDragDropQuestionReducer(state, action) {

  switch (action.type) {
    case ON_SUBMIT:
      return onGelSubmit(state, action.payload);
    case ON_RESET:
      return onGelReset(state, action.payload);
    case CLOSE_FEEDBACK:
      return onCloseFeedback(state, action.payload);
    case ON_GEL_UPDATE:
      return onGelUpdate(state, action.payload);
    case ON_GEL_SELECT:
      return onGelSelect(state, action.payload);

    // New reducer methods for drop down question
    case ON_DROP_DOWN_SUBMIT:
      return onDropDownSubmit(state, action.payload);
    case ON_DROP_DOWN_RESET:
      return onDropDownReset(state, action.payload);
    case CLOSE_DROP_DOWN_FEEDBACK:
      return onDropDownCloseFeedback(state, action.payload);
    case ON_DROP_DOWN_UPDATE:
      return onDropDownUpdate(state, action.payload);
    case ON_DROP_DOWN_SELECT:
      return onDropDownSelect(state, action.payload);


    default:
      return state;
  }
}
